;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import { styled } from "@mui/material/styles"
import MuiAccordion from "@mui/material/Accordion"
import MuiAccordionSummary from "@mui/material/AccordionSummary"
import MuiAccordionDetails from "@mui/material/AccordionDetails"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import {
  UI_STYLE_PRIMARY_BLUE_BLACK,
  UI_STYLE_PRIMARY_FONT,
} from "../../../../../../lib/constants"

const Accordion = styled(MuiAccordion)({
  background: "#EAEAEA",
  boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.25)",
  borderRadius: "15px !important",
  "&:not(:first-of-type)": {
    marginTop: "10px",
  },
  "& .MuiAccordion-rounded": {
    borderTopLeftRadius: "15px",
  },
  "&:before": {
    display: "none",
  },
  fontFamily: UI_STYLE_PRIMARY_FONT,
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "18px",
  lineHeight: "25px",
  letterSpacing: "0.03em",
  color: UI_STYLE_PRIMARY_BLUE_BLACK,
})

const AccordionSummary = styled(MuiAccordionSummary)(({ theme }) => ({
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}))

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}))

function AccordionItem({
  panel,
  accordionSummaryTypography,
  accordionDetailsTypography,
  handleChange,
  expanded,
}) {
  return (
    <Accordion
      elevation={0}
      expanded={expanded === panel}
      onChange={handleChange(panel)}
      key={panel}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel-${panel}-content`}
        id={`panel-${panel}-header`}
      >
        {accordionSummaryTypography}
      </AccordionSummary>
      <AccordionDetails>
        {Array.isArray(accordionDetailsTypography)
          ? accordionDetailsTypography.map((detail, index) => (
              <React.Fragment key={`accordion-details-${panel}-${index}`}>
                {detail}
              </React.Fragment>
            ))
          : accordionDetailsTypography}
      </AccordionDetails>
    </Accordion>
  )
}

export default AccordionItem
